<template>
  <div>
    <h3>查看班级内容</h3>
    <el-form label-width="120px" @submit.native.prevent="creategrade">
      <el-form-item label="选择网校">
        <el-select
          clearable
          v-model="model.maID"
          placeholder="网校"
          @change="getprice"
        >
          <el-option
            v-for="item in major"
            :key="item.maID"
            :label="item.maName"
            :value="item.maID"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="一级分类">
        <el-select
          clearable
          v-model="model.chID"
          multiple
          placeholder="一级分类"
          @change="getCourse"
        >
          <el-option
            v-for="item in channel"
            :key="item.chID"
            :label="item.chName"
            :value="item.chID"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="二级分类">
        <el-select
          clearable
          v-model="model.coID"
          multiple
          @change="getClass"
          placeholder="二级分类"
        >
          <el-option
            v-for="item in course"
            :key="item.coID"
            :label="item.coName"
            :value="item.coID"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <!-- 显示表格 -->
    <template v-show="price">
      <el-table :data="price" border style="width: 100%">
        <el-table-column
          prop="createAt"
          label="创建时间"
          width="85"
          :formatter="formatDate"
        >
        </el-table-column>
        <el-table-column prop="major" label="网校" width="90">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.major" :key="tag.index">
              <el-tag>{{ tag.maName }}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="channel" label="一级分类" width="115">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.channel" :key="tag.index">
              <el-tag style="margin: 3px" v-show="tag.chName">{{
                tag.chName
              }}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="course" label="二级分类" width="150">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.course" :key="tag.index">
              <el-tag style="margin: 3px" v-show="tag.coName">{{
                tag.coName
              }}</el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="prpdf" label="电子资料" width="155">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.prpdf" :key="tag.index"
              ><el-tag style="margin: 3px">{{ tag.prPdfName }}</el-tag></span
            >
          </template>
        </el-table-column>
        <el-table-column prop="prvideo" label="视频课程" width="180">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.prvideo" :key="tag.index"
              ><el-tag style="margin: 3px">{{ tag.prVideoName }}</el-tag></span
            >
          </template>
        </el-table-column>
        <el-table-column prop="prservice" label="教学服务" width="180">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.prservice" :key="tag.index"
              ><el-tag style="margin: 3px">{{
                tag.prServiceName
              }}</el-tag></span
            >
          </template>
        </el-table-column>
        <el-table-column prop="prteachway" label="学习方式" width="120">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.prteachway" :key="tag.index"
              ><el-tag style="margin: 3px">{{
                tag.prTeachWayName
              }}</el-tag></span
            >
          </template>
        </el-table-column>
        <el-table-column prop="prteachtime" label="课程期限" width="270">
          <template slot-scope="scope">
            <span v-for="tag in scope.row.prteachtime" :key="tag.index"
              ><el-tag style="margin: 3px">{{
                tag.prTeachTimeName
              }}</el-tag></span
            >
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              @click="$router.push(`/price/edit/${scope.row._id}`)"
              type="primary"
              icon="el-icon-edit"
              size="small"
              plain
              >编辑</el-button
            >
            <el-button
              style="margin: 15px 3px 3px 0px"
              @click="priceDelete(scope.row._id)"
              type="danger"
              size="small"
              icon="el-icon-delete"
              plain
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-skeleton :loading="loading" :rows="10" animated />
    </template>

    <!--  grade分类分页 -->
    <div class="price-page">
      <el-pagination
        @size-change="changeSize"
        @current-change="currentChange"
        :current-page="currentPage"
        @prev-click="pricepre"
        @next-click="pricenext"
        background
        layout="prev, pager, next,total,jumper,sizes"
        :total="priceLength"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { timerfilter } from "../util/timerfilter";

export default {
  data() {
    return {
      loading: true,
      currentPage: 1,
      pageSize: 10,
      priceLength: 0,
      major: [],
      channel: [],
      course: [],
      price: [],
      //grade: [],
      model: {},
      prvideo: [{ prVideoId: Date.now(), prVideoName: "" }],
      prpdf: [{ prPdfId: Date.now(), prPdfName: "" }],
      prservice: [{ prServiceId: Date.now(), prServiceName: "" }],
      prteachway: [{ prTeachWayId: Date.now(), prTeachWayName: "" }],
      prteachtime: [{ prTeachTimeId: Date.now(), prTeachTimeName: "" }],
    };
  },

  methods: {
    async getprice() {
      try {
        const getprice = await this.$http.get("/category/getprice", {
          params: {
            chID: this.model.chID,
            maID: this.model.maID,
            coID: this.model.coID,
            page: this.currentPage,
            size: this.pageSize,
          },
        });
        this.price = getprice.data[0].result;
        this.priceLength = getprice.data[0].resultLength[0].totalCount;
        this.loading = false;
      } catch (error) {
        console.log("错误：", error.message);
      }
    },
    async getMajor() {
      try {
        const getmajor = await this.$http.get("/major/getmajor");
        this.major = getmajor.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel() {
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        this.channel = getchannel.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(chID) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID },
        });
        this.course = getcourse.data;
        this.getprice(chID);
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(coID) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID },
        });
        this.clclass = getclass.data;
        this.getprice(coID);
      } catch (error) {
        console.log(error);
      }
    },

    //删除price
    priceDelete(id) {
      this.$confirm("此操作将永久删除且不能恢复, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "waring",
        center: true,
      })
        .then(async () => {
          const res = await this.$http.get(
            "/category/deleteprice?_id=" + `${id}`
          );
          if (res.status === 203) {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          }
          this.getprice();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //日期格式化插件
    formatDate(row, column) {
      let date = row[column.property];
      if (date == null) {
        return null;
      }
      //console.log(date)
      return timerfilter(date); //moment(date).format('YYYY-MM-DD HH:mm')
    },
    //price分类分页
    async pricepre() {
      this.currentPage--;

      //this.getTertiary(this.pageSize);
      //console.log("上一页");
    },
    async pricenext() {
      this.currentPage++;
      // this.getTertiary(this.pageSize);
      //console.log(this.pageSize);
    },
    async changeSize(size) {
      this.pageSize = size;
    },
    async currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getprice(this.currentPage);
      //console.log(this.currentPage);
    },
  },
  created() {
    this.getMajor();
    this.getChannel();
    this.getprice();
    //this.getgrade();
  },
};
</script>
